import React from 'react';
import '../../css/Stars.css';
import star_yellow from '../../assets/star_yellow.png';
import star_grey from '../../assets/star_grey.png';

export const Stars = ({ score }) => {
    const yellowStars = Math.round(score);
    const greyStars = 5 - yellowStars;

    return (
        <div className="stars-container">
            {Array.from({ length: yellowStars }).map((_, index) => (
                <img
                    key={`yellow-${index}`}
                    loading="lazy"
                    src={star_yellow}
                    alt="Yellow star icon"
                    className="star-icon"
                />
            ))}

            {Array.from({ length: greyStars }).map((_, index) => (
                <img
                    key={`grey-${index}`}
                    loading="lazy"
                    src={star_grey}
                    alt="Gray star icon"
                    className="star-icon"
                />
            ))}
        </div>
    );
};
